import { gql } from "@apollo/client";

export const GET_USER_DEPOSIT_BALANCE = gql`
  query UserDepositBalance {
    userDepositBalance
  }
`;

export const GET_USER_DEPOSIT_CHARGES = gql`
  query UserDepositCharges {
    userDepositCharges {
      id
      userId
      orderId
      tid
      amount
      depositAmountBefore
      depositAmountAfter
      isApproved
      isCanceled
      canceledAt
      cancelReason
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_DEPOSIT_CHARGE_ORDER = gql`
  mutation CreateDepositChargeOrder($input: CreateDepositChargeInput!) {
    createDepositChargeOrder(input: $input) {
      orderId
      amount
      nicePayClientKey
      nicePaySecretKey
      returnUrl
      mallReserved
    }
  }
`;

export const CREATE_CAMPAIGN_PARTICIPATION_WITHOUT_CHARGE = gql`
  mutation CreateCampaignParticipationWithoutCharge($campaignRunId: Int!) {
    createCampaignParticipationWithoutCharge(campaignRunId: $campaignRunId) {
      participationId
    }
  }
`;

export const CANCEL_DEPOSIT_CHARGE = gql`
  mutation CancelDepositCharge($depositChargeId: Int!, $cancelReason: String) {
    cancelDepositCharge(
      depositChargeId: $depositChargeId
      cancelReason: $cancelReason
    ) {
      ok
      error
    }
  }
`;

export const CANCEL_PARTICIPATION = gql`
  mutation CancelParticipation($participationId: Int!, $cancelReason: String) {
    cancelParticipation(
      participationId: $participationId
      cancelReason: $cancelReason
    ) {
      ok
      error
    }
  }
`;
